'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  default: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'currentColor',
    textTransform: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  caption: {
    fontSize: _reactackleCore.fontSizeSmall,
    lineHeight: 1.25,
    color: _reactackleCore.fontColorMedium,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(0.5)
  },
  body: {
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  bodyStrong: {
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightSemibold,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  subheading: {
    fontSize: _reactackleCore.fontSizeBody2,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  title: {
    fontSize: _reactackleCore.fontSizeTitle,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightSemibold,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  headline: {
    fontSize: _reactackleCore.fontSizeHeadline,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  display1: {
    fontSize: _reactackleCore.fontSizeDisplay1,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  display2: {
    fontSize: _reactackleCore.fontSizeDisplay2,
    lineHeight: 1.6,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  display3: {
    fontSize: _reactackleCore.fontSizeDisplay3,
    lineHeight: 1.3,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightNormal,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  },
  display4: {
    fontSize: _reactackleCore.fontSizeDisplay4,
    lineHeight: 1.3,
    color: _reactackleCore.bodyFontColor,
    textTransform: 'none',
    fontWeight: _reactackleCore.fontWeightLight,
    letterSpacing: 'initial',
    fontFamily: 'inherit',
    marginTop: 0,
    marginBottom: 0,
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
  }
};